import { useMutation } from '@tanstack/react-query'
import { setAppSpinning } from 'app/appSlice'
import { useAppDispatch } from 'hooks/useRedux'
import { useEffect, useState } from 'react'

export default function useExportById(mutateApi, fileName, fileType) {
  const dispatch = useAppDispatch()

  const [file, setFile] = useState(null)
  const mutation = useMutation({
    mutationKey: 'exportById',
    mutationFn: mutateApi,
    onMutate: () => dispatch(setAppSpinning(true)),
    onSettled: () => dispatch(setAppSpinning(false)),
    onSuccess: (res) => {
      const fileUrl = `${process.env.REACT_APP_BASE_URL}${res.metadata?.fileURL || res?.fileURL}`
      window.open(fileUrl, '_blank')
    },
  })

  useEffect(() => {
    if (file) {
      const url = URL.createObjectURL(file)
      open(url, '_blank')
    }
    return () => {
      URL.revokeObjectURL(file)
      setFile(null)
    }
  }, [file])
  return {
    file,
    exportFunc: mutation.mutate,
    exportFuncAsync: mutation.mutateAsync,
  }
}
